import { useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';

import { FeatureFlagContextProvider } from '@dndbeyond/character-components/es';
import { featureFlagInfoSelectors } from '@dndbeyond/character-rules-engine/es';

import ErrorBoundary from '../../../Shared/components/ErrorBoundary';
import CharacterBuilder from '../CharacterBuilder';

export function CharacterBuilderContainer(props) {
    const featureFlagInfo = useSelector(featureFlagInfoSelectors.getFeatureFlagInfo);
    useLayoutEffect(() => {
        document
            .getElementsByTagName('body')[0]
            .classList.add('site', 'body-rpgcharacterbuilder', 'site-dndbeyond', 'body-rpgcharacter');
        return () => {
            document
                .getElementsByTagName('body')[0]
                .classList.remove('site', 'body-rpgcharacterbuilder', 'site-dndbeyond', 'body-rpgcharacter');
        };
    }, []);
    return (
        <ErrorBoundary>
            <FeatureFlagContextProvider featureFlagInfo={featureFlagInfo}>
                <CharacterBuilder />
            </FeatureFlagContextProvider>
        </ErrorBoundary>
    );
}

export default CharacterBuilderContainer;
